const INFO_API_PREFIX = import.meta.env.VITE_INFO_API_PREFIX;
const descriptionsKey = 'x-ss-descriptions';
const eventKeysKey = 'x-ss-eventKeys';
import { api } from '@/modules/apiv2';
import { getSeverityFromEventEntry } from '@/mixins.js';

let descriptionsDownloaded = false;

export default {
  state: {
    descriptions: JSON.parse(localStorage.getItem(descriptionsKey)),
    eventKeys: JSON.parse(localStorage.getItem(eventKeysKey)),
    ownerApiListData: null,
    severity: {
      info: 'bg-green',
      alert: 'bg-orange',
      alarm: 'bg-red',
    }
  },

  getters: {
    eventKeys(state) {
      return state.eventKeys;
    },
    
    severity(state) {
      return state.severity;
    },

    descriptions(state) {
      return state.descriptions;
    },

    eventAlarms(state) {
      if (state.descriptions.DescriptionsByEventKey) {
        return Object.entries(state.descriptions.DescriptionsByEventKey)
          .filter((entry) => {
            return getSeverityFromEventEntry(entry[1]) === 'Alarm';
          })
          .map((entry) => {
            return entry[0];
          });
      }

      return [];
    },

    eventAlerts(state) {
      if (state.descriptions.DescriptionsByEventKey) {
        return Object.entries(state.descriptions.DescriptionsByEventKey)
          .filter((entry) => {
            return getSeverityFromEventEntry(entry[1]) === 'Alert';
          })
          .map((entry) => {
            return entry[0];
          });
      }

      return [];
    },

    eventInfos(state) {
      if (state.descriptions.DescriptionsByEventKey) {
        return Object.entries(state.descriptions.DescriptionsByEventKey)
          .filter((entry) => {
            return getSeverityFromEventEntry(entry[1]) === 'info';
          })
          .map((entry) => {
            return entry[0];
          });
      }

      return [];
    },

    eventOther(state) {
      if (state.descriptions.DescriptionsByEventKey) {
        return Object.entries(state.descriptions.DescriptionsByEventKey)
          .filter((entry) => {
            return getSeverityFromEventEntry(entry[1]) !== 'Alarm' && 
              getSeverityFromEventEntry(entry[1]) !== 'Alert' &&
              getSeverityFromEventEntry(entry[1]) !== 'info';
          })
          .map((entry) => {
            return entry[0];
          });
      }

      return [];
    },

    eventKeyDescription: (state) => (eventKey) => {
      try {
        return state.descriptions.DescriptionsByEventKey[eventKey].Description;
      } catch {
        return eventKey;
      }
    },
  },

  mutations: {
    setDescriptions(state, descriptions) {
      state.descriptions = descriptions;
    },

    setEventKeys(state, eventKeys) {
      state.eventKeys = eventKeys;
    },
  },

  actions: {
    getEventKeys({ commit }) {
      return api
        .get(`/${INFO_API_PREFIX}/keys`)
        .then((data) => {
          localStorage.setItem(eventKeysKey, JSON.stringify(data));
          commit('setEventKeys', data);
          return data;
        })
        .catch((error) => {
          throw error;
        });
    },

    async getDescriptions({ commit }) {
      if (descriptionsDownloaded) {
        return;
      }

      descriptionsDownloaded = true;

      const data = await api.get(`/${INFO_API_PREFIX}/descriptions`);
      localStorage.setItem(descriptionsKey, JSON.stringify(data));
      commit('setDescriptions', data);

      return data;
    },
  },
};
